import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {ElasticsearchState} from '@local/redux/state/elasticsearch';

const initialState: ElasticsearchState = {};
const elasticsearchSlice = createSlice({
  name: 'elasticsearch',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<ElasticsearchState>) => {
      return action.payload;
    },
    clear: () => {
      return initialState;
    },
  },
});
export const elasticsearchReducer = elasticsearchSlice.reducer;
export const elasticsearchActions = elasticsearchSlice.actions;
